export enum EAppLoggerCategory {
    GENERAL = 'general',
    GQL = 'gql',
    REST = 'rest',
}
